// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-fg0wrIADodsrdSiMDST7 {
    cursor: pointer;
}

.header-BR_ASyJbo2eM1DCJozQK {
    height: 190px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

.header-BR_ASyJbo2eM1DCJozQK > table {
    width: 400px;
}

.header-BR_ASyJbo2eM1DCJozQK > table > thead {
    border-bottom: 1px solid white;
}

.header-BR_ASyJbo2eM1DCJozQK > table > * > tr > td,
.header-BR_ASyJbo2eM1DCJozQK > table > * > tr > th {
    padding: 2px 6px;
    min-width: 90px;
}

.truck-selector-container-wJmYAM1oNyxU5lbWkWA8 {
    position: absolute;
    right: 0;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    margin: 20px;
}

.truck-id-tag-Z5Jc8qW35sw5tH0vhtRx {
    margin-right: 20px;

    font-size: 18px;
}

.truck-id-textbox-ETDqwC31bsbq8rcYP4_c {
    margin-right: 20px;

    padding: 4px 10px;
    color: white;
}

.truck-selector-ghiOqwBnqEhV11eVg9AC {
    margin-right: 30px;

    font-size: 30px;
    color: red;

    cursor: pointer;
}

.truck-selector-ghiOqwBnqEhV11eVg9AC.enabled-ZtUzzhLtB_6kkiSlo6YL {
    color: green;
}

.content-fypMtipKs15t_RH4RdgD {
    height: calc(100% - 190px);
    width: 100%;
    display: inline-flex;
    flex-direction: row;
}

.tab-list-OVJBSA3iZpVZ3_ZDL2x5 {
    display: flex;
    flex-direction: row;
}

.tab-jhbD86Tqt4sJaDJAftAQ {
    background-color: var(--light-grey);
    cursor: pointer;
    padding: 10px 20px;
}

.tab-jhbD86Tqt4sJaDJAftAQ.selected-qb89EnGkw3yoNkbTiTpg {
    background-color: var(--blue);
}

.panel-OIpMh9jWMwXVTwlidtcx {
    padding: 30px;

    height: 100%;
    box-sizing: border-box;
}

.left-info-panel-it82YfvSuMZ35E7YSODm {
    position: relative;
    top: -150px;
    width: 480px;
}

.middle-super-panel-uyAqL_uM7BpTDqfIzQ3M {
    width: 900px;
}

.panel-hidden-sSzLMljcrzyjPVYCnfGO {
    display: none;
}

.buttons-rq4xjhlW1FEBcRFSHIUw {
    position: relative;
    top: -80px;
    height: calc(100% + 80px);
    overflow-y: auto;
    overflow-x: hidden;

    display: flex;
    flex-direction: column;
    align-items: center;
}

.buttons-rq4xjhlW1FEBcRFSHIUw > *,
.super-buttons-DwDp180H85DUUqyMpgGR > * {
    margin: 7px;
}

.button-row-mErLHUN5s19QWCTXrE6g {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.button-row-mErLHUN5s19QWCTXrE6g > * {
    margin: 0 5px;
}

hr {
    width: 100%;
}

.athletes-tab-_oPu_U2nCe8sm7_I7lJ7 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.set-no-athlete-button-MpG7T4uXjjrQus06fmdC {
    cursor: pointer;
    padding: 15px 30px;

    margin-top: 20px;

    border: 1px solid white;
    border-radius: 4px;
}

.set-no-athlete-button-MpG7T4uXjjrQus06fmdC:hover {
    background-color: var(--light-grey);
}

.set-no-athlete-button-MpG7T4uXjjrQus06fmdC.selected-qb89EnGkw3yoNkbTiTpg {
    background-color: var(--blue);
}

.supers-tab-aj3tMP1zZp3xV8RoqpvL {
    height: 100%;

    display: flex;
    flex-direction: row;
}

.supers-tab-list-hxJ3QdA52xuHyoQRpYeT {
    min-width: 0;
    display: flex;
    flex-direction: row;
}

.super-table-EfAtdqnKv_5TnyJcCrLW {
    width: 600px;
    height: 600px;
    margin-right: 30px;
}

.super-buttons-DwDp180H85DUUqyMpgGR {
    flex-shrink: 0;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
}

.custom-leaderboard-vb3x2n1OvfFwfuelOpIj {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.leaderboard-title-selector-qngG9Eh1pIVebbU9svmw {
    width: 400px;
    padding: 10px 4px;
}

.custom-leaderboard-table-wQx9bjtUPiu8bEYnHREU td {
    padding: 6px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Graphics/index.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;;IAER,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;;IAEnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;;IAElB,eAAe;AACnB;;AAEA;IACI,kBAAkB;;IAElB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;;IAElB,eAAe;IACf,UAAU;;IAEV,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;;IAEb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;;IAElB,gBAAgB;;IAEhB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;;IAEZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".title {\n    cursor: pointer;\n}\n\n.header {\n    height: 190px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.header > table {\n    width: 400px;\n}\n\n.header > table > thead {\n    border-bottom: 1px solid white;\n}\n\n.header > table > * > tr > td,\n.header > table > * > tr > th {\n    padding: 2px 6px;\n    min-width: 90px;\n}\n\n.truck-selector-container {\n    position: absolute;\n    right: 0;\n\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n\n    margin: 20px;\n}\n\n.truck-id-tag {\n    margin-right: 20px;\n\n    font-size: 18px;\n}\n\n.truck-id-textbox {\n    margin-right: 20px;\n\n    padding: 4px 10px;\n    color: white;\n}\n\n.truck-selector {\n    margin-right: 30px;\n\n    font-size: 30px;\n    color: red;\n\n    cursor: pointer;\n}\n\n.truck-selector.enabled {\n    color: green;\n}\n\n.content {\n    height: calc(100% - 190px);\n    width: 100%;\n    display: inline-flex;\n    flex-direction: row;\n}\n\n.tab-list {\n    display: flex;\n    flex-direction: row;\n}\n\n.tab {\n    background-color: var(--light-grey);\n    cursor: pointer;\n    padding: 10px 20px;\n}\n\n.tab.selected {\n    background-color: var(--blue);\n}\n\n.panel {\n    padding: 30px;\n\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.left-info-panel {\n    position: relative;\n    top: -150px;\n    width: 480px;\n}\n\n.middle-super-panel {\n    width: 900px;\n}\n\n.panel-hidden {\n    display: none;\n}\n\n.buttons {\n    position: relative;\n    top: -80px;\n    height: calc(100% + 80px);\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.buttons > *,\n.super-buttons > * {\n    margin: 7px;\n}\n\n.button-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.button-row > * {\n    margin: 0 5px;\n}\n\nhr {\n    width: 100%;\n}\n\n.athletes-tab {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.set-no-athlete-button {\n    cursor: pointer;\n    padding: 15px 30px;\n\n    margin-top: 20px;\n\n    border: 1px solid white;\n    border-radius: 4px;\n}\n\n.set-no-athlete-button:hover {\n    background-color: var(--light-grey);\n}\n\n.set-no-athlete-button.selected {\n    background-color: var(--blue);\n}\n\n.supers-tab {\n    height: 100%;\n\n    display: flex;\n    flex-direction: row;\n}\n\n.supers-tab-list {\n    min-width: 0;\n    display: flex;\n    flex-direction: row;\n}\n\n.super-table {\n    width: 600px;\n    height: 600px;\n    margin-right: 30px;\n}\n\n.super-buttons {\n    flex-shrink: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: 100%;\n}\n\n.custom-leaderboard {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.leaderboard-title-selector {\n    width: 400px;\n    padding: 10px 4px;\n}\n\n.custom-leaderboard-table td {\n    padding: 6px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `title-fg0wrIADodsrdSiMDST7`,
	"header": `header-BR_ASyJbo2eM1DCJozQK`,
	"truck-selector-container": `truck-selector-container-wJmYAM1oNyxU5lbWkWA8`,
	"truckSelectorContainer": `truck-selector-container-wJmYAM1oNyxU5lbWkWA8`,
	"truck-id-tag": `truck-id-tag-Z5Jc8qW35sw5tH0vhtRx`,
	"truckIdTag": `truck-id-tag-Z5Jc8qW35sw5tH0vhtRx`,
	"truck-id-textbox": `truck-id-textbox-ETDqwC31bsbq8rcYP4_c`,
	"truckIdTextbox": `truck-id-textbox-ETDqwC31bsbq8rcYP4_c`,
	"truck-selector": `truck-selector-ghiOqwBnqEhV11eVg9AC`,
	"truckSelector": `truck-selector-ghiOqwBnqEhV11eVg9AC`,
	"enabled": `enabled-ZtUzzhLtB_6kkiSlo6YL`,
	"content": `content-fypMtipKs15t_RH4RdgD`,
	"tab-list": `tab-list-OVJBSA3iZpVZ3_ZDL2x5`,
	"tabList": `tab-list-OVJBSA3iZpVZ3_ZDL2x5`,
	"tab": `tab-jhbD86Tqt4sJaDJAftAQ`,
	"selected": `selected-qb89EnGkw3yoNkbTiTpg`,
	"panel": `panel-OIpMh9jWMwXVTwlidtcx`,
	"left-info-panel": `left-info-panel-it82YfvSuMZ35E7YSODm`,
	"leftInfoPanel": `left-info-panel-it82YfvSuMZ35E7YSODm`,
	"middle-super-panel": `middle-super-panel-uyAqL_uM7BpTDqfIzQ3M`,
	"middleSuperPanel": `middle-super-panel-uyAqL_uM7BpTDqfIzQ3M`,
	"panel-hidden": `panel-hidden-sSzLMljcrzyjPVYCnfGO`,
	"panelHidden": `panel-hidden-sSzLMljcrzyjPVYCnfGO`,
	"buttons": `buttons-rq4xjhlW1FEBcRFSHIUw`,
	"super-buttons": `super-buttons-DwDp180H85DUUqyMpgGR`,
	"superButtons": `super-buttons-DwDp180H85DUUqyMpgGR`,
	"button-row": `button-row-mErLHUN5s19QWCTXrE6g`,
	"buttonRow": `button-row-mErLHUN5s19QWCTXrE6g`,
	"athletes-tab": `athletes-tab-_oPu_U2nCe8sm7_I7lJ7`,
	"athletesTab": `athletes-tab-_oPu_U2nCe8sm7_I7lJ7`,
	"set-no-athlete-button": `set-no-athlete-button-MpG7T4uXjjrQus06fmdC`,
	"setNoAthleteButton": `set-no-athlete-button-MpG7T4uXjjrQus06fmdC`,
	"supers-tab": `supers-tab-aj3tMP1zZp3xV8RoqpvL`,
	"supersTab": `supers-tab-aj3tMP1zZp3xV8RoqpvL`,
	"supers-tab-list": `supers-tab-list-hxJ3QdA52xuHyoQRpYeT`,
	"supersTabList": `supers-tab-list-hxJ3QdA52xuHyoQRpYeT`,
	"super-table": `super-table-EfAtdqnKv_5TnyJcCrLW`,
	"superTable": `super-table-EfAtdqnKv_5TnyJcCrLW`,
	"custom-leaderboard": `custom-leaderboard-vb3x2n1OvfFwfuelOpIj`,
	"customLeaderboard": `custom-leaderboard-vb3x2n1OvfFwfuelOpIj`,
	"leaderboard-title-selector": `leaderboard-title-selector-qngG9Eh1pIVebbU9svmw`,
	"leaderboardTitleSelector": `leaderboard-title-selector-qngG9Eh1pIVebbU9svmw`,
	"custom-leaderboard-table": `custom-leaderboard-table-wQx9bjtUPiu8bEYnHREU`,
	"customLeaderboardTable": `custom-leaderboard-table-wQx9bjtUPiu8bEYnHREU`
};
export default ___CSS_LOADER_EXPORT___;
